/**
 * @file: expo-video-thumbnails.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const getThumbnailAsync = async () => {
  throw new Error('Not supported on web');
};
